import dagre, { graphlib } from 'dagre';
import { type Node, type Edge, type XYPosition } from "reactflow";

export function autoLayout(
  nodes: Node[],
  edges: Edge[],
  algorithm: 'NETWORK' | 'LINEAR' = 'NETWORK',
  nodeWidth: number = 150,
  nodeHeight: number = 100,
  ranksep: number = 100,
  nodesep: number = 30
): {[key: string]: XYPosition} {
    const nodePositions: {[key: string]: XYPosition} = {};

    if (algorithm == 'LINEAR') {
        const g = new graphlib.Graph();
        g.setGraph({
            rankdir: 'LR',
            nodesep: nodesep, // Vertical spacing between nodes in the same rank
            ranksep: ranksep, // Horizontal spacing between ranks
        });
        g.setDefaultEdgeLabel(() => {
            return {};
        });

        nodes.forEach((node) => {
            g.setNode(node.id, { width: nodeWidth, height: nodeHeight });
        });

        edges.forEach((edge) => {
            g.setEdge(edge.source, edge.target);
        });

        dagre.layout(g);

        nodes.forEach((node) => {
            const nodeWithPosition = g.node(node.id);
            // We are shifting the dagre node position (anchor=center center) to the top left
            // so it matches the React Flow node anchor point (top left).
            nodePositions[node.id] = {
                x: nodeWithPosition.x - nodeWidth / 2,
                y: nodeWithPosition.y - nodeHeight / 2
            };
        });

        return nodePositions;
    }
    
    // For NETWORK algorithm, we'd need Springy, but for now just return empty
    // This can be implemented later if needed
    return nodePositions;
}

